<template>
  <div>
    <div style="display: flex; justify-content: center; margin: 0 auto;">
      <div v-show="loader" class="preloader">
        <div class="lds-ripple">
          <div class="lds-pos"></div>
          <div class="lds-pos"></div>
        </div>
      </div>
    </div>
    <div
      class="auth-wrapper img-fluid d-flex no-block justify-content-center align-items-center position-relative"
    >
      <div class="shadow auth-box row text-center">
        <!-- image city -->
        <div
          v-show="windowWidth > 780"
          class="foo col-lg-7 col-md-5 modal-bg-img"
        ></div>
        <div class="col-lg-5 col-md-7 bg-white">
          <br />
          <div
            v-show="message.state"
            class="alert alert-dismissible border-0 fade show"
            :class="message.type"
            role="alert"
          >
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <strong>{{ message.msg }}</strong>
          </div>
          <div class="p-3">
            <img
              src="../../../public/logo/vivot_violet.png"
              class="img-fluid"
              alt="vivot_logo"
            />
            <br />
            <br />
            <div class="mt-2 text-center mb-5"></div>

            <form class="">
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group">
                    <input
                      v-model="email"
                      class="form-control"
                      type="email"
                      placeholder="email address"
                      required
                    />
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="form-group">
                    <input
                      v-model="password"
                      class="form-control"
                      type="password"
                      placeholder="password"
                      required
                      @keyup.enter="login"
                    />
                  </div>
                </div>
                <div class="col-lg-12 text-center">
                  <button
                    type="button"
                    class="btn btn-block btn-danger btn-rounded"
                    @click="login"
                  >
                    Login
                  </button>
                </div>
                <div class="col-lg-12 text-center mt-5 mb-5">
                  Don't have an account?
                  <a href="/register" class="text-danger">Sign Up</a>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baseApiURL } from '../../configs';
export default {
  name: 'Login',
  components: {},
  data() {
    return {
      message: {
        state: false,
        msg: '',
        type: '',
      },
      valid: false,
      email: '',
      password: '',
      status: '',
      userId: '',
      windowWidth: window.innerWidth,
      loader: false,
      user_object: null,
    };
  },
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
  },
  methods: {
    login() {
      this.loader = true;
      this.message.state = false;
      const { email } = this;
      const { password } = this;
      if (!this.emptyFields()) {
        this.$store
          .dispatch('login', { email, password })
          .then(() => {
            this.userId = this.$store.state.user.userId;
            if (this.userId) {
              this.getAvatar(this.userId);
              //this.$router.push('/dashboard');
            } else {
              window.location = '/user/account';
              //this.$router.push('/user/account');
            }
          })
          .catch(err => {
            console.log(err);
            this.email = '';
            this.password = '';
            this.message.msg = err.response.data.message;
            this.message.type = 'alert-warning';
            this.message.state = true;
            this.loader = false;
          });
      } else {
        this.email = '';
        this.password = '';
        this.message.msg = 'The fields are required';
        this.message.type = 'alert-warning';
        this.message.state = true;
        this.loader = false;
      }
    },
    emptyFields() {
      return this.email === '' || this.password === '';
    },
    getAvatar(userId) {
      this.$http
        .get(`/user/file/GetPhoto?userId=${userId}`)
        // eslint-disable-next-line no-unused-vars
        .then(res => {
          //console.log('entra');
          this.user_object = JSON.parse(localStorage.getItem('user'));
          this.user_object.avatar = `${baseApiURL}/api/user/file/GetPhoto?userId=${userId}`;
          localStorage.setItem('user', JSON.stringify(this.user_object));
          this.$store.state.user = this.user_object;
          window.location = '/dashboard';
        })
        // eslint-disable-next-line no-unused-vars
        .catch(err => {
          window.location = '/dashboard';
        });
    },
  },
};
</script>
<style lang="scss">
.vivot-background {
  /*../../../public/background/Frame-4.png*/
  background: url(../../../public/background/Frame-4.png) center no-repeat;
  background-attachment: scroll;
}

.foo {
  background-image: url(../../../public/background/background_login.jpg);
}
</style>
